// extracted by mini-css-extract-plugin
export var bound = "index-module--bound--1013b";
export var slide_inner = "index-module--slide_inner--eef5b";
export var slider = "index-module--slider--d24fc";